import IntlService from 'ember-intl/services/intl';
import { parseNumber } from 'volta/utils/math-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { IBvInlineEditCommonArgs } from '../';

interface IArgs extends IBvInlineEditCommonArgs {
  onSave?: (value?: number) => void | Promise<void>;
  unit?: string;
  value?: string | number;
  defaultValue?: string | number;
  style: 'decimal' | 'percent';
  formattedValueLabel?: string;
}

export default class BvInlineNumberEdit extends Component<IArgs> {
  @service intl!: IntlService;

  @tracked intermediateValue?: number = this.parseValue(this.args.value);

  get formattedValue() {
    const value = this.args.value ?? 0;

    if (!isNaN(parseFloat(`${value}`)) && isFinite(+value)) {
      return this.style === 'percent'
        ? this.intl.formatNumber(+value, { style: 'percent' })
        : this.intl.formatNumber(+value);
    } else {
      return '';
    }
  }

  get style() {
    return this.args.style ?? 'decimal';
  }

  get isPositive() {
    return this.args.value && +this.args.value >= 0;
  }

  @action
  save() {
    if (this.args.disabled) {
      return;
    }

    return this.args.onSave?.(this.parseValue(this.intermediateValue));
  }

  @action
  cancel() {
    if (this.args.disabled) {
      return;
    }

    if (!this.isDestroyed) {
      this.intermediateValue = this.parseValue(this.args.value);
    }

    return this.args.onCancel?.();
  }

  protected parseValue(value: number | string | undefined) {
    return parseNumber(value);
  }
}
